import { Component, OnInit, Inject } from '@angular/core';
import { environment, ConstVariable } from 'src/environments/environment';
import { FormBuilder, FormControl, FormGroup, Validators, FormsModule } from '@angular/forms';
import { HttpEventType, HttpClient, HttpHeaders } from "@angular/common/http";
import { LookupInfo } from '../../model/lookup.model';
import { GlobalService } from '../../service/global.service';
import { TokenService } from '../../service/token.service';
import { SubStateInfo } from '../../model/SubStateInfo.model';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-sub-state',
  templateUrl: './sub-state.component.html',
  styleUrls: ['./sub-state.component.css']
})
export class SubStateComponent implements OnInit {
  /************************* Variables ************************** */
  baseurl: string;
  _EmpCode: string;

  //Parameters from URL
  _ParamCycleCode: string;
  _ParamStateCode: string;

  //SubState Model
  ListStatus: LookupInfo[] = [];
  ListSubStateManagement: SubStateInfo[] = [];
  SubStateInfo: SubStateInfo = new SubStateInfo;

  //Search
  isSearchSubmitted: boolean = false;
  txtSchSubStateName: string;
  txtSchSubStateCode: string;
  ddlSchSubStateStatus: string = "";

  //Form variable
  SubStateForm: FormGroup;
  IsDuplicateCode: boolean;

  //Pagination
  indexNo: number = 0;
  currentPageNumber: number = 1;
  totalSubState: number = 0;
  totalPages: number = 0;
  pageSize: number;

  //Loading
  displayloading: boolean = false;
  Msgloadding: string = '';

  //Modal
  titlemodal: string;
  detailmodal: string;


  /************************* End Variables ************************** */
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router, private activaterouter: ActivatedRoute) {
    this.baseurl = environment.base_api;
    //Set param
    this.activaterouter.params.subscribe(params => {
      this._ParamCycleCode = params['CycleCode'];
      this._ParamStateCode = params['StateCode'];
    });
  }

  ngOnInit() {

    //Init data
    this.currentPageNumber = 1;
    this.pageSize = environment.PageSizeMedium;
    this._EmpCode = localStorage.getItem("EmpCode");
    this.ddlSchSubStateStatus = 'Y'

    //Load init data
    this.LoadLookupType("SubStateSTATUS").then((data) => {
      this.ListStatus = data;
    });

    this.LoadSubStateList().then((data) => {
      this.ListSubStateManagement = data;
    });
    this.LoadCountSubStateList();

    //Declare form
    this.SubStateForm = new FormGroup({
      SubStateCode: new FormControl(this.SubStateInfo.SubStateCode, [Validators.required]),
      SubStateName: new FormControl(this.SubStateInfo.SubStateName, [Validators.required]),
    });
  }

  get SubStateCode() { return this.SubStateForm.get('SubStateCode'); }
  get SubStateName() { return this.SubStateForm.get('SubStateName'); }

  async LoadLookupType(LookupType) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['LookupType'] = LookupType;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
        .toPromise();
    }
  }
  async LoadSubStateList(dataId: number = 0): Promise<SubStateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['SubStateCode'] = this.txtSchSubStateCode;
      objectjson['SubStateName'] = this.txtSchSubStateName;

      objectjson['CycleCode'] = this._ParamCycleCode;
      objectjson['StateCode'] = this._ParamStateCode;

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<SubStateInfo[]>(this.baseurl + "MasterSale/GetSubStateManagementList", strjson, httpOptions)
        .toPromise()
    }
  }
  async LoadCountSubStateList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SubStateCode'] = this.txtSchSubStateCode;
      objectjson['SubStateName'] = this.txtSchSubStateName;

      objectjson['CycleCode'] = this._ParamCycleCode;
      objectjson['StateCode'] = this._ParamStateCode;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<number>(this.baseurl + "MasterSale/GetCountSubStateManagementList", strjson, httpOptions)
        .toPromise().then((data) => {
          this.SetTotalpagePagination(data);
        });
    }
  }

  OnSearch_Click() {
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = true;
    this.LoadSubStateList().then((data) => {
      this.ListSubStateManagement = data;
    });
  }
  OnClear_Click() {
    this.txtSchSubStateCode = null;
    this.txtSchSubStateName = null;
    $('#ddlSchSubStateStatus').val('')

    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.isSearchSubmitted = false;
    this.LoadSubStateList().then((data) => {
      this.ListSubStateManagement = data;
    });
  }

  //Create btn
  OnCreateSubState_Click() {

    $('#modalCreateSubStateTitle').html('Create Sub State DOA');
    $('#modalCreateOrEditSubState').modal();
    this.SubStateInfo = new SubStateInfo;
    this.SubStateCode.setValue(null);
    this.SubStateName.setValue(null);

    this.SubStateForm.markAsUntouched();
    this.SubStateForm.markAsPristine();
  }

  async OnSubmitCreateSubState_Click() {
    if (this.SubStateForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        var objectjson = this.SubStateForm.value;
        objectjson['SubStateCode'] = this.SubStateForm.get('SubStateCode').value;
        objectjson['SubStateName'] = this.SubStateForm.get('SubStateName').value;

        objectjson['CycleCode'] = this._ParamCycleCode;
        objectjson['StateCode'] = this._ParamStateCode;

        objectjson['CreateBy'] = this._EmpCode;

        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/InsertSubStateManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            this.titlemodal = '';
            this.detailmodal = 'SubState has been created successfully.';
            $('#ModalComplate .modal-header').text('Information');
            $('#ModalComplate .modal-header').addClass('bg-gold');
            $('#ModalComplate').modal();
            $('#modalCreateOrEditSubState').modal('hide');

            //Reload
            setTimeout(() => {
              this.LoadSubStateList().then((data) => {
                this.ListSubStateManagement = data;
              });
              this.LoadCountSubStateList();
            }, 300);
          });
      }
    } else {
      this.markFormGroupTouched(this.SubStateForm);
    }

  }
  async OnEdit_Click(SubStateId) {

    if (!!SubStateId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadSubStateList(SubStateId).then((data) => {

          this.SubStateInfo = data[0];
          this.SubStateCode.setValue(data[0].SubStateCode);
          this.SubStateName.setValue(data[0].SubStateName);

          setTimeout(() => {

            $('#modalCreateSubStateTitle').html('Edit SubState DOA');
            $('#modalCreateOrEditSubState').modal();
          }, 500);
        });
      }
    }
  }
  async OnSubmitEdit_Click() {
    if (this.SubStateForm.valid && !this.IsDuplicateCode) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };

        //ปรับ flag ก่อนนำไป save ลง DB
        var objectjson = this.SubStateForm.value;
        objectjson['SubStateCode'] = this.SubStateForm.get('SubStateCode').value;
        objectjson['SubStateName'] = this.SubStateForm.get('SubStateName').value;

        objectjson['CycleCode'] = this._ParamCycleCode;
        objectjson['StateCode'] = this._ParamStateCode;

        objectjson['UpdateBy'] = this._EmpCode;
        objectjson['Id'] = this.SubStateInfo.Id;


        let strjson = JSON.stringify(objectjson);

        console.log(strjson);

        this.httpClient.post<any>(this.baseurl + "MasterSale/UpdateSubStateManagement", strjson, httpOptions)
          .toPromise().then((data) => {
            if (!!data) {
              this.titlemodal = '';
              this.detailmodal = 'SubState has been updated successfully.';
              $('#ModalComplate .modal-header').text('Information');
              $('#ModalComplate .modal-header').addClass('bg-gold');
              $('#ModalComplate').modal();
              $('#modalCreateOrEditSubState').modal('hide');

              //Reload
              this.LoadSubStateList().then((data) => {
                this.ListSubStateManagement = data;
              });
            } else {
              this.titlemodal = 'Fail.';
              this.detailmodal = 'Position was updated fail.';
              $('#ModalError').modal();
              $('#modalCreateOrEditSubState').modal('hide');

            }
          });
      }
    } else {
      this.markFormGroupTouched(this.SubStateForm);
    }
  }
  async OnDelete_Click(SubStateId) {
    if (confirm("Are you sure you want to delete this sub-state ?")) {
      if (!!SubStateId) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };

          var objectjson = this.SubStateForm.value;
          objectjson['StateCode'] = this._ParamStateCode;
          objectjson['CycleCode'] = this._ParamCycleCode;
          objectjson['UpdateBy'] = this._EmpCode;
          objectjson['Id'] = SubStateId;

          let arrjson: SubStateInfo[] = [];
          arrjson.push(objectjson);
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteSubStateManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {
                this.isSearchSubmitted = false;
                this.titlemodal = '';
                this.detailmodal = 'SubState has been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                //Reload
                this.LoadSubStateList().then((data) => {
                  this.ListSubStateManagement = data;
                });

              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    }
  }
  async OnDeleteList_Click() {
    var listDeleteChecked = $('[name="checkboxdelete"]:checked');
    let arrjson: SubStateInfo[] = [];
    var that = this;
    //เก็บ List id ที่จะ delete
    $.each(listDeleteChecked, function (idx, val) {
      var curId = $(val).data('positionid');
      var model = new SubStateInfo;
      model.Id = curId;
      model.CycleCode = that._ParamCycleCode;
      model.StateCode = that._ParamStateCode;
      arrjson.push(model);
    });

    if (arrjson.length > 0) {
      if (confirm("Are you sure to delete these sub-states?")) {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          //ส่งไป Delete
          const httpOptions = {
            headers: new HttpHeaders({
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth_token}`
            })
          };
          let strjson = JSON.stringify(arrjson);

          console.log(strjson);

          this.httpClient.post<any>(this.baseurl + "MasterSale/DeleteSubStateManagement", strjson, httpOptions)
            .toPromise().then((data) => {
              if (!!data) {

                this.titlemodal = '';
                this.detailmodal = 'SubStates have been deleted successfully.';
                $('#ModalComplate .modal-header').text('Information');
                $('#ModalComplate .modal-header').addClass('bg-gold');
                $('#ModalComplate').modal();

                setTimeout(() => {
                  this.isSearchSubmitted = false;
                  //Reload
                  this.LoadSubStateList().then((data) => {
                    this.ListSubStateManagement = data;
                  });
                  this.LoadCountSubStateList()
                }, 500);


              }
              else {

                this.titlemodal = 'Fail.';
                this.detailmodal = 'Delete fail.';
                $('#ModalError').modal();

              }
            });
        }
      }
    } else {

      this.titlemodal = 'Fail.';
      this.detailmodal = 'Please select DOA to delete at lease 1 row.';
      $('#ModalError .modal-header').text("Sorry");
      $('#ModalError').modal();
    }
  }
  async OnMapping_Click(wfType, groupCode) {
    this.router.navigate(['/SubState-doa-mapping', { wf: wfType, groupcode: groupCode }])
  }

  //Name position clicked
  async OnAddRights_Click(positionId) {
    if (!!positionId) {

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadSubStateList(positionId).then((data) => {

          this.SubStateInfo = data[0];
          this.SubStateCode.setValue(data[0].SubStateCode);
          this.SubStateName.setValue(data[0].SubStateName);

          setTimeout(() => {

            $('#modalCreateSubStateTitle').html('Edit SubState');
            $('#modalCreateOrEditSubState').modal();
          }, 500);
        });
      }
    }
  }
  async CheckDuplicateCode() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['SubStateCode'] = this.SubStateCode.value;
      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      this.httpClient.post<boolean>(this.baseurl + "MasterSale/CheckDuplicateSubStateManagementCode", strjson, httpOptions)
        .toPromise()
        .then(data => {

          this.IsDuplicateCode = data;

        })
        .catch(err => {

          this.IsDuplicateCode = false;

        });
    }
  }

  //Pagination
  OnLoadListFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber = traget.currentPageNumber;
      this.totalPages = traget.totalPages;
      this.indexNo = traget.index;
    }

    this.LoadSubStateList().then((data) => {
      this.ListSubStateManagement = data;
    });;
  }
  SetTotalpagePagination(data) {
    this.totalSubState = data;
    if (this.totalSubState == 0) {
      this.currentPageNumber = 0;
    }
    this.totalPages = Math.ceil(this.totalSubState / environment.PageSizeMedium);
  }

  //Private function
  private Loading(flag: boolean, Msg: string = '') {
    this.displayloading = flag;
    this.Msgloadding = Msg;
  }
  private markFormGroupTouched(formGroup: FormGroup) {
    (<any>Object).values(formGroup.controls).forEach(control => {
      control.markAsTouched();


      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
